import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditCategory = props => {
  let redirectPath
  let categoryId
  if (props.routes.find(route => route.path === 'events')) {
    redirectPath = '/events/categories'
    categoryId = props.params.id
  } else {
    redirectPath = '/ecommerce/categories'
    categoryId = props.params.categoryId
  }

  return (
    <Edit
      title='Edit Category'
      fields={fields}
      apiPath={`admin/categories/${categoryId}`}
      successRedirectPath={redirectPath}
      buildMenuItems={menuItems}
    />
  )
}

export default EditCategory
